import { render, staticRenderFns } from "./DataPending.vue?vue&type=template&id=24038303&scoped=true"
var script = {}
import style0 from "./DataPending.vue?vue&type=style&index=0&id=24038303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24038303",
  null
  
)

export default component.exports